import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

// Zeigt einen Toast aus lib/bs_toast.js und entfernt ihn nach dem Ausblenden. Vor dem Turbo-Cache wird er entfernt,
// damit er beim Zurück-Navigieren nicht erneut erscheint.
export default class extends Controller {
  static values = {
    autohide: { type: Boolean, default: true },
    duration: { type: Number, default: 4000 },
  }

  connect() {
    this.element.addEventListener("hidden.bs.toast", () => this.element.remove(), { once: true })
    this.toast = Toast.getOrCreateInstance(this.element, { autohide: this.autohideValue, delay: this.durationValue })
    this.toast.show()
  }

  disconnect() {
    this.toast?.dispose()
  }

  beforeTurboCache() {
    this.element.remove()
  }
}
